module.exports = __webpack_public_path__ + "static/media/accreditation_polices_procedures.20f2c7c7.svg";